module.exports = __webpack_public_path__ + "static/media/logo_ppdb_online_domsav.fa13e39d.png";